<div
  class="table-header"
  #tableHeaderElement
  [class.sticky]="isTableHeaderSticky"
  [class.table-header--with-sublabels]="hasSubLabels"
>
  <div class="table-header__row" [ngClass]="{ 'table-header__row--disabled': isDisabled }">
    <div class="table-header__checkbox" *ngIf="isCheckboxColumnVisible">
      <mat-checkbox
        color="primary"
        [checked]="isCheckboxChecked"
        [(ngModel)]="isCheckboxChecked"
        (change)="toggleCheckboxChange($event)"
      ></mat-checkbox>
    </div>
    <div class="table-header__columns-box">
      <div
        *ngFor="let itemTH of tableHeader"
        class="table-header__column"
        [matTooltip]="itemTH.tooltipText || ''"
        [style.width.%]="itemTH.percentageWidth"
        (click)="orderBy(itemTH)"
        [class.table-header__column--clickeable]="itemTH.isOrderByVisible"
      >
        <div class="table-header__labels">
          <div class="table-header__title-row">
            <span
              class="table-header__name subheading-01-semi-bold"
              [class.table-header__name--selected]="orderByColumn == itemTH.id && itemTH.isOrderByVisible"
              >{{ itemTH.text }}</span
            >
            <div
              *ngIf="itemTH.isOrderByVisible"
              class="table-header__arrow"
              [class.table-header__arrow--selected]="orderByColumn == itemTH.id"
              [class.table-header__arrow--des]="orderByOrientation == 'DES'"
            ></div>
          </div>
          <span *ngIf="itemTH.subLabel" class="table-header__sub-label">{{
            itemTH.subLabel
          }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
